import { runInAction } from 'mobx';
import { isEmptyArray } from '../../../utils/array-utils';
import { getFilmAvailability } from '../../browsing/selectors/films/get-film-availability';
import { getFilterByIdAndType } from '../selectors/get-filter-by-id-and-type';
import { filterDomainStore } from '../store';
import { FilterType } from '../types/filter-type';
import { createFilterOptions } from '../utils/create-filter-option';
import { createFilterSection } from '../utils/create-filter-section';
import { updateFilterSection } from './utils/update-filter-section';
export const createFilmFilter = (id, films, siteId, fixedValues) => {
    const existingFilter = getFilterByIdAndType(id, FilterType.Film);
    const newFilms = films.filter(film => !(existingFilter === null || existingFilter === void 0 ? void 0 : existingFilter.baseData.includes(film.id)));
    // No need to update the existing filter if the underlying data hasn't changed.
    if (existingFilter && isEmptyArray(newFilms))
        return;
    const genreOptions = createFilterOptions(getGenreIdsForFilms(films));
    const attributeOptions = createFilterOptions(getAttributeIdsForFilms(films, siteId));
    const eventOptions = createFilterOptions(getEventIdsForFilms(films));
    const categoryOptions = createFilterOptions(getCategoriesForFilms(films, siteId));
    const filmIds = films.map(film => film.id);
    // Update existing filter.
    if (existingFilter) {
        runInAction(() => {
            updateFilterSection(existingFilter.sections.genre, genreOptions);
            updateFilterSection(existingFilter.sections.attribute, attributeOptions);
            updateFilterSection(existingFilter.sections.event, eventOptions);
            updateFilterSection(existingFilter.sections.category, categoryOptions);
            existingFilter.baseData = filmIds;
        });
        return;
    }
    // Create a new filter.
    const filter = {
        id,
        siteId,
        type: FilterType.Film,
        sections: {
            genre: createFilterSection(genreOptions, fixedValues === null || fixedValues === void 0 ? void 0 : fixedValues.genre),
            attribute: createFilterSection(attributeOptions, fixedValues === null || fixedValues === void 0 ? void 0 : fixedValues.attribute),
            event: createFilterSection(eventOptions, fixedValues === null || fixedValues === void 0 ? void 0 : fixedValues.event),
            category: createFilterSection(categoryOptions, fixedValues === null || fixedValues === void 0 ? void 0 : fixedValues.category)
        },
        baseData: filmIds
    };
    runInAction(() => {
        filterDomainStore.data.filmFilters[id] = filter;
    });
};
const getGenreIdsForFilms = (films) => {
    const genreIds = films.reduce((acc, film) => {
        film.genreIds.forEach(genreId => acc.add(genreId));
        return acc;
    }, new Set());
    return [...genreIds];
};
const getAttributeIdsForFilms = (films, siteId) => {
    const attributeIds = films.reduce((acc, film) => {
        const filmAvailability = getFilmAvailability(film.id, siteId);
        if (!filmAvailability)
            throw new Error(`Cannot find film availability with filmId: ${film.id}.`);
        filmAvailability.showtimeAttributeIds.forEach(attributeId => acc.add(attributeId));
        return acc;
    }, new Set());
    return [...attributeIds];
};
const getEventIdsForFilms = (films) => {
    const eventIds = films.reduce((acc, film) => {
        if (film.eventId)
            acc.add(film.eventId);
        return acc;
    }, new Set());
    return [...eventIds];
};
const getCategoriesForFilms = (films, siteId) => {
    const categories = films.reduce((acc, film) => {
        const filmAvailability = getFilmAvailability(film.id, siteId);
        if (!filmAvailability)
            throw new Error(`Cannot find film availability with filmId: ${film.id}.`);
        filmAvailability.categories.forEach(category => acc.add(category));
        return acc;
    }, new Set());
    return [...categories];
};
